@if (errorMessage) {
  <p-message class="api-load-error" severity="error" icon="pi pi pi-times-circle" [closable]="true">
    <p class="font-semibold">{{ errorMessage.summary }}</p>
    <p>{{ errorMessage.detail }}</p>
  </p-message>
}

<ng-container *accessView="['WelcomeContent.Read']">
  @if (showReferralWelcomePage) {
    <referral-welcome-page />
  }
  <p-toast key="faxIssue" position="center" class="long-messages" />
  @if (isExternalUser) {
    @if (!isAdminPanelExternalWelcomeContentEnabled) {
      <app-welcome-page />
    } @else {
      <app-welcome-content />
    }
  }
</ng-container>

@if (!isExternalUser) {
  <ng-container *accessView="['HomePage.UI']">
    <ng-container *accessController="['AppealGrievance']">
      <!-- New security permission: 'AppealGrievanceQueue.Read'-->
      @if (selectedQueueType === queueTypes.AGQueue) {
        <app-appeals-and-grievances-queue />
      }
    </ng-container>
    @if (selectedQueueType === queueTypes.SdohQueue) {
      <nexus-sdoh-queue></nexus-sdoh-queue>
    }
    <ng-container *accessController="['STARsOperations']">
      <ng-container *accessView="['STARsQueue.Read']">
        <div class="p-4">
          <div class="mb-2">
            @if (selectedQueueType === queueTypes.StarsQueue) {
              <app-queue-action-buttons
                >
                <ng-container additional-action>
                  <div class="flex additional-queue-actions">
                    <mnc-stars-on-hold-referrals-button lazyComponent></mnc-stars-on-hold-referrals-button>
                    <mnc-stars-staffing-report-button lazyComponent></mnc-stars-staffing-report-button>
                  </div>
                </ng-container>
              </app-queue-action-buttons>
            }
          </div>
          @if (selectedQueueType === queueTypes.StarsQueue) {
            <mnc-stars-queue
              lazyComponent
              (referralNumberClicked)="navigateToMemberPage($event, 'STARs')"
              (memberClicked)="navigateToMemberPage($event)"/>
          }
        </div>
      </ng-container>
    </ng-container>
    <ng-container
      *accessController="[
        'OperationsAdmin',
        'LetterMapsManager',
        'Internal',
        'AppealGrievance',
        'Operations',
        'DMEPOSMedicareOperations',
        'DMEPOSMedicaidOperations'
      ]">
      <ng-container *accessView="['HHServiceLineQueue.Read']">
        @if (selectedQueueType === queueTypes.HHQueue) {
          <hh-platform-queue />
        }
      </ng-container>
    </ng-container>
    <ng-container *accessView="['PACMAServiceLineQueue.Read', 'PACCOMServiceLineQueue.Read']">
      @if (selectedQueueType === queueTypes.PACQueue || selectedQueueType === queueTypes.PACCommercialQueue) {
        <div class="p-4 queue-table">
          <div class="mb-2">
            <app-queue-action-buttons></app-queue-action-buttons>
          </div>
          <mnc-pac-queue
            lazyComponent
            [queueType]="selectedQueueType"
            (authNumberClicked)="navigateToPACAuth($event)"
            (memberClicked)="navigateToMemberPage($event)">
          </mnc-pac-queue>
        </div>
      }
    </ng-container>
    <ng-container *accessView="['DMEPOSAuthorizationCaseQueue.Read', 'DMEPOSMedicaidQueue.Read']">
      @if (selectedQueueType === queueTypes.DMEPOS_MA || selectedQueueType === queueTypes.DMEPOS_MCD) {
        <dmepos-queue
          [lineOfBusiness]="selectedQueueType === queueTypes.DMEPOS_MA ? 'Medicare Advantage' : 'Medicaid'"
          />
      }
    </ng-container>
    <ng-container *accessView="['WoundCareAdmissionQueue.Read']">
      @if (selectedQueueType === queueTypes.WCCAdmissionsQueue) {
        <div class="p-4 queue-table">
          <div class="mb-2">
            <app-queue-action-buttons></app-queue-action-buttons>
          </div>
          <mnc-wcc-queue
            lazyComponent
            (authNumberClicked)="navigateToHHAuth($event)"
            (referenceNumberClicked)="navigateToMemberPage($event, 'wound-management')">
          </mnc-wcc-queue>
        </div>
      }
    </ng-container>
  </ng-container>
}
